/**
 * Helper service
 */
export default class HelperService {
  /**
   * Generate deviceGuid for betslip placement request
   */
  static generateDeviceGuid() {
    return `${this.generateRandomString(32)}${this.isMobile.any().replace(/\s/g, '__')}`;
  }

  /**
   * Generate random string of given length
   */
  static generateRandomString(len) {
    let symbols = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let out = '';
    for (let i = len; i > 0; i -= 1) {
      out += symbols[Math.round(Math.random() * (symbols.length - 1))];
    }
    return out;
  }

  /**
   * Check mobile device for generating deviceGuid
   * @type {{}}
   */
  static isMobile = {
    Android: () => {
      if (navigator.userAgent.match(/Android/i)) {
        return navigator.userAgent;
      }
      return false;
    },
    BlackBerry: () => {
      if (navigator.userAgent.match(/BlackBerry/i)) {
        return navigator.userAgent;
      }
      return false;
    },
    iOS: () => {
      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        return navigator.userAgent;
      }
      return false;
    },
    Opera: () => {
      if (navigator.userAgent.match(/Opera Mini/i)) {
        return navigator.userAgent;
      }
      return false;
    },
    Windows: () => {
      if (navigator.userAgent.match(/IEMobile/i)) {
        return navigator.userAgent;
      }
      return false;
    },
    any: () => {
      let isMob = (HelperService.isMobile.Android() ||
        HelperService.isMobile.BlackBerry() ||
        HelperService.isMobile.iOS() ||
        HelperService.isMobile.Opera() ||
        HelperService.isMobile.Windows());
      if (isMob === false) {
        return `__Desktop_V${APP_SETTINGS.version}__${navigator.userAgent}`;
      }
      return `__Mobile_V${APP_SETTINGS.version}__${isMob}`;
    },
  };

  /**
   * Get total usage of betslip in local storage
   */
  static getLocalStorageBetslipSize() {
    let totalUsage = 0;
    if (localStorage.getItem('betslip')) {
      totalUsage = (localStorage.getItem('betslip').length * 2) / 1024 / 1024;
    }
    return `${totalUsage.toFixed(2)}MB`;
  }
  /**
   * General debounce method
   * iw we pass only fn as param it will use requestAnimationFrame
   * @param {Function} fn
   * @param {Number} wait
   * @param {Boolean} immediate
   */
  static debounce(fn, wait= null, immediate = false) {
    // when we use rAF and it is not supported use setTimeout
    if (!wait && !window.requestAnimationFrame) {
      wait = 1000 / 60;
    }
    // Setup a timer
    let timeout;
    // Return a function to run debounced
    return function () {
      const functionCall = () => {
        if (!immediate) fn.apply(this, arguments);
      };
      let callNow = immediate && !timeout;
      if (wait) {
        // debounce using setTimeout
        clearTimeout(timeout);
        timeout = setTimeout(functionCall, wait);
      } else {
        // debounce using rAF
        // If there's a timer, cancel it
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }
        // Setup the new requestAnimationFrame()
        timeout = window.requestAnimationFrame(functionCall);
      }
      if (callNow) fn.apply(this, arguments);
    };
  }
}
